// ANCHOR React
import React, { memo } from 'react';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Components
import { ImageBadge } from '@lyon/components/utils/ImageBadge';
import { BadgeColor } from '@lyon/components/utils/ImageBadge/styles';

const APPROVAL_COLOR = {
  pending: BadgeColor.default,
  rejected: BadgeColor.negative,
  approved: BadgeColor.positive,
};

export const LyonCourseCardStatus = memo(() => {
  const [myCourse, approvalStatus] = CourseCardData.useSelectors((state) => [
    state.myCourse,
    state.approvalStatus,
  ]);

  if (myCourse && approvalStatus) {
    return (
      <ImageBadge color={APPROVAL_COLOR[approvalStatus]}>
        { approvalStatus === 'pending'
          ? 'pending'
          : approvalStatus }
      </ImageBadge>
    );
  }

  return null;
});
